import React from 'react';

const RightArrow = ({ width = 16, height = 16, fill = '#ADADAD' }) => {
  return (
    <svg
      className="right-arrow-icon"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893C6.90237 0.683417 6.90237 1.31658 7.29289 1.70711L12.5858 7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H12.5858L7.29289 14.2929C6.90237 14.6834 6.90237 15.3166 7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071L15.7064 8.70782C15.7088 8.70541 15.7112 8.70298 15.7136 8.70055C15.8901 8.52079 15.9992 8.27463 16 8.003C16 8.002 16 8.001 16 8C16 7.999 16 7.998 16 7.997C15.9996 7.8625 15.9727 7.73425 15.9241 7.61722C15.8764 7.50195 15.8063 7.3938 15.7136 7.29945C15.7112 7.29705 15.7089 7.29466 15.7065 7.29228M8.70711 0.292893L15.7065 7.29228L8.70711 0.292893Z"
        fill={fill}
      />
    </svg>
  );
};

export default RightArrow;
